export default function initCopyToClipboard() {
  Alpine.data('copyToClipboard', () => ({
    copied: false,
    clickToCopy() {
      const { text } = this.$el.dataset;
      if (window.isSecureContext && navigator.clipboard && text) {
        navigator.clipboard.writeText(text);
      }
      this.copied = true;
      setTimeout(() => {this.copied = false;}, 3000);
    },
  }));
}
